import React from "react";
import { install } from "ga-gtag";
import { Box, AppBar, Toolbar, Stack, Button, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const Navbar = () => {
	install("G-7GEX43MK8X");
	const navigate = useNavigate();

	return (
		<Box sx={{flexGrow: 1}}>
			<AppBar position="fixed" sx={{zIndex: (theme) => theme.zIndex.drawer + 1}}>
				<Toolbar style={{margin: "0 auto", padding: "0 20px", maxWidth: 1600, width: "100%", minHeight: 82}}>
					<Box>
						<Link sx={{mr: 5, display: "flex", cursor: "pointer"}} onClick={() => navigate("/")}>
							<img style={{width: 156}} src="./img/logo.svg" alt="Company Logo" />
							<img src="./img/your-key-to-profit.png" alt="Your Key To Profit Logo" />
						</Link>
					</Box>
					<Box sx={{flexGrow: 1}} />
					<Stack spacing={2} direction="row" sx={{
						"& .MuiButton-root": {
							color: "#5e5745",
							"&:hover": {
								bgcolor: "rgba(94, 87, 69, 0.04)"
							}
						}
					}}>
						<Button variant="text" onClick={() => navigate("/")}>Home</Button>
						<Button variant="text" href="https://profit.choiceuniversity.net/">Your Key to Profit</Button>
						<Button variant="text" href="mailto:profit@choicehotels.com">Contact</Button>
						<Button variant="text" href="https://choiceuniversity.net/">ChoiceU.com</Button>
					</Stack>
				</Toolbar>
			</AppBar>
		</Box>
	);
};